const axios = require("axios").default;

const URL = `${process.env.REACT_APP_API_URL}/return/myapproval`;
const URL_RETURN = `${process.env.REACT_APP_API_URL}/return`;
const URL_PARAM = `${process.env.REACT_APP_API_URL}/param`;
const URL_REQUEST_FAREYE = `${process.env.REACT_APP_API_URL}/request`;

export const getAll = (payload) => {
  return axios.get(URL, {
    params: payload,
  });
};

export const postPrint = (retNumber) => {
  return axios.post(`${URL_RETURN}/${retNumber}/print`);
};

export const postFile = (retNumber, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios.post(`${URL_RETURN}/${retNumber}/fpre`, formData);
};

export const getFile = (retNumber) => {
  return axios.get(`${URL_RETURN}/${retNumber}/fpre`);
};

export const getFareye = (retNumber) => {
  return axios.get(`${URL_REQUEST_FAREYE}/${retNumber}/fareye`);
};

export const postApproval = (retNumber, payload) => {
  return axios
    .post(`${URL_RETURN}/${retNumber}/approve`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const postRejectApproval = (retNumber, payload) => {
  return axios
    .post(`${URL_RETURN}/${retNumber}/reject`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const deleteFpre = (id) => {
  return axios.delete(`${URL_RETURN}/${id}/fpre`);
};

export const getParam = (payload) => {
  return axios.get(URL_PARAM, {
    params: payload,
  });
};
export const getMultiplePrint = (payload) => {
  return axios
    .get(`${URL_RETURN}/multiform?id=${payload}`, {
      params: payload,
      responseType: "blob",
    })

    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
